import { LocationsStatus } from '../components/LocationStatus';
import { isLocationVisible, useLocationRow } from '../locationRow';
import { type LocationListItemsType } from '../types';
import { ItemBadge, ItemDescription, ItemDetails, ItemLabel } from './styles';

type LocationItemContentProps = {
  item: LocationListItemsType;
  /** Search results can relabel an item, so the label comes from the dropdown row. */
  label: string;
  multiSelect: boolean;
  hideInactiveLocations: boolean;
  showStatusLabel: boolean;
};

export const LocationItemContent = ({
  item,
  label,
  multiSelect,
  hideInactiveLocations,
  showStatusLabel,
}: LocationItemContentProps) => {
  const { description, locationCount, badge, showStatus } = useLocationRow({
    item,
    hideInactiveLocations,
    multiSelect,
    showStatusLabel,
  });
  const hasVisibleChildren = item.children.some((child) =>
    isLocationVisible(child, hideInactiveLocations),
  );

  return (
    <>
      <ItemLabel bold={hasVisibleChildren} data-testid={`location-picker-label-${item.value}`}>
        {label}
      </ItemLabel>
      {(description || badge) && (
        <ItemDetails>
          {description && showStatus && <LocationsStatus isActive={!!item.meta?.isActive} />}
          {badge && <ItemBadge variant={badge.variant}>{badge.name}</ItemBadge>}
          {description && (
            <ItemDescription data-testid={`location-picker-description-${item.value}`}>
              {description}
            </ItemDescription>
          )}
        </ItemDetails>
      )}
      {locationCount && <ItemDescription>{locationCount}</ItemDescription>}
    </>
  );
};
